export default function ReMark({ allCaps = false, className = "" }) {
  const extra = className ? ` ${className}` : "";
  if (allCaps) {
    return (
      <span className={`re-mark re-mark--caps${extra}`}>
        <span className="re-mark__re">RE</span>CHECKLIST
      </span>
    );
  }
  return (
    <span className={`re-mark${extra}`}>
      <span className="re-mark__re">RE</span>Checklist
    </span>
  );
}
